import styled from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { ACCORDION_ITEM_SPACING } from '../StripeElementsProvider/utils';

// CS-only layout wrappers. NOT reused from PaymentElementsForm/styles —
// those are tuned for the control's 55px buttons + a 12px rhythm. Here the express
// wallets, PayPal, and the card form should read as one tight, evenly-spaced group, so
// every grouped element gets the same bottom gap. Editing these does not affect the
// control flow.
export const GROUP_GAP = '0.5rem';

// The express element renders ~8px taller than its 44px wallet buttons (Stripe's own
// container, not this wrapper — this wrapper has no padding/min-height), so we keep its
// own margin to the shared group gap and let the visible buttons drive the rhythm.
export const ExpressCheckoutWrapper = styled.div`
	margin: 0 0 ${GROUP_GAP};
`;

export const PaypalWrapper = styled.div`
	margin: 0 0 ${GROUP_GAP};
`;

export const TruemedWrapper = styled.div`
	margin: ${ACCORDION_ITEM_SPACING} 0 0;
`;

// Hides the PaymentElement's DOM node until it has something to show (`onLoaderStart`/
// `onReady`) — it stays mounted throughout (unmounting would mean it never fires either
// event), with a `<Loader />` shown alongside instead of a blank region. `visibility`, not
// `display` — Stripe's iframe sizes itself off the available layout width, which a
// `display: none` ancestor collapses to zero and can leave it never resolving to "ready" at
// all; `visibility: hidden` keeps that width available while still hiding the paint.
export const PaymentElementWrapper = styled.div<{ $isVisible: boolean }>`
	visibility: ${ifProp('$isVisible', 'visible', 'hidden')};
`;

// Positions the deferred-remount loading overlay against the payment-options block beneath
// it, without affecting that block's own layout or the rest of the form.
export const FormContainer = styled.div`
	position: relative;
`;

// Covers the payment-options region while a background create is settling for a newer
// plan/coupon/promo selection — the stale form stays mounted and visually present underneath
// (dimmed), matching the "no layout shift" requirement (absolute + inset, not a replacement
// layout). `pointer-events: none` while merely loading is cosmetic only: the real submit-time
// guard lives in CheckoutSessionsFormInner's confirm(), not here. The loading sub-state has
// nothing to click, so it stays click-through; the FAILED sub-state (`$interactive`) holds a
// real "Try again" button and must accept clicks itself.
export const UpdatingOverlay = styled.div<{ $interactive?: boolean }>`
	align-items: center;
	background: ${palette('whiteAlpha80')};
	bottom: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	left: 0;
	pointer-events: ${ifProp('$interactive', 'auto', 'none')};
	position: absolute;
	right: 0;
	top: 0;
	z-index: 1;
`;
